export default __webpack_public_path__ + "static/media/ftj-1.72ed7e5b.jpeg";